// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import VueClipboard from 'vue-clipboard2';
import VueAnalytics from 'vue-analytics';
import {getCookie} from './util/util' //引用刚才我们创建的util.js文件，并使用getCookie,setCookie方法
import pressEvent from './util/pressEvent'
import * as filters from './filters';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import NProgress from 'nprogress'; // 进度条
import 'nprogress/nprogress.css'; //这个样式必须引入
import webSocket from './util/webscoket';

import FBSignInButton from 'vue-facebook-signin-button'; 
Vue.use(FBSignInButton)
import 'default-passive-events'
Date.prototype.Format = function(fmt)
{
  var o = {
    "M+" : this.getMonth()+1,                 //月份
    "d+" : this.getDate(),                    //日
    "h+" : this.getHours(),                   //小时
    "m+" : this.getMinutes(),                 //分
    "s+" : this.getSeconds(),                 //秒
    "q+" : Math.floor((this.getMonth()+3)/3), //季度
    "S"  : this.getMilliseconds()             //毫秒
  };
  if(/(y+)/.test(fmt))
    fmt=fmt.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o){

    if(new RegExp("("+ k +")").test(fmt)){
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)));
    }

  }
  return fmt;
};


Vue.config.productionTip = false
Vue.use(pressEvent);
Vue.use(VueClipboard);
Vue.use(VueReCaptcha, {
  siteKey: '6LefWLIUAAAAAIJg1CKdEIX3LyendLts47EyMGyJ',
  loaderOptions: {
    useRecaptchaNet: true,
    autoHideBadge:true
  }
})
Vue.use(VueAnalytics, {
  id: 'UA-44990675-3',
  disableScriptLoader: true,
  router,
  autoTracking: {
    pageviewOnLoad: false
  }
});

//注册全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});


// 简单配置
NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (!webSocket.WS || webSocket.WS.readyState != 1) {
    webSocket.init()
  }
  if (to.meta.requireAuth) {  // 判断该路由是否需要登录权限
    if (getCookie('token')) {  // 通过vuex state获取当前的token是否存在
      if (to.meta.availableCheck){
        if (store.state.personalInfo.limited[to.meta.cfg]=='X'){
            next({
              path:to.meta.toPage,
            })
        }else{
          next();
        }
      } else {
        next();
      }
    }
    else {
      next({
        path: '/login',
        query: {redirect: to.fullPath}  // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }
  else {
    next();
  }
})
router.afterEach(() => {
  NProgress.done()
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});


// WEBPACK FOOTER //
// ./src/main.js